import React, { useEffect, useRef, useState } from 'react';
import { useZoom } from 'yet-another-react-lightbox-lite';
import ZoomInIcon from '@mui/icons-material/ZoomIn';
import Box from '@mui/material/Box';
import IconButton from '@mui/material/IconButton';
import Slider from '@mui/material/Slider';

export const JucyLightBoxZoomButton = () => {
    const { zoom, maxZoom, changeZoom } = useZoom();

    const [open, setOpen] = useState(false);

    const buttonRef = useRef<HTMLButtonElement | null>(null);
    const sliderRef = useRef<HTMLInputElement | null>(null);

    useEffect(() => {
        if (open) {
            sliderRef.current?.focus();
        }
    }, [open]);

    return (
        <>
            <IconButton
                ref={buttonRef}
                type="button"
                title="Zoom"
                aria-label="Zoom"
                className="yarll__button"
                disabled={maxZoom === 1}
                onClick={() => setOpen(!open)}
                size="small"
            >
                <ZoomInIcon fontSize="inherit" className="yarll__icon" />
            </IconButton>
            {open ? (
                <Box
                    sx={(theme) => ({
                        zIndex: 1,
                        display: 'flex',
                        gap: 2,
                        alignItems: 'center',
                        position: 'absolute',
                        top: theme.spacing(5),
                        right: theme.spacing(1),
                        px: 2,
                        py: 0.5,
                        borderRadius: 1,
                        backgroundColor: theme.palette.background.paper,
                        boxShadow: 3,
                        color: theme.palette.text.secondary,
                        typography: 'body2',
                        fontWeight: '700',
                    })}
                    onBlur={(event) => {
                        if (event.relatedTarget !== buttonRef.current) {
                            setOpen(false);
                        }
                    }}
                    onKeyDown={(event) => {
                        event.stopPropagation();
                    }}
                >
                    <Slider
                        color="secondary"
                        ref={sliderRef}
                        min={0}
                        max={maxZoom}
                        step={0.04}
                        value={zoom}
                        onChange={(event, value) => changeZoom(value as number)}
                        aria-label="Zoom"
                        aria-valuetext={`${Math.round(zoom * 100)}%`}
                        sx={{
                            m: 0,
                            p: 0,
                            width: '200px',
                        }}
                    />
                    <Box sx={{ width: '30px' }}>{Math.round(zoom * 100)}%</Box>
                </Box>
            ) : null}
        </>
    );
};
